import { Tag } from 'antd';
import { useMemo } from 'react';

import { MIGRATION_STATUSES, TAG_STATUS_DEFAULT } from '@app/constants';

import type { StatusTagProps } from '@pages/DataMigration/DataMigration.types';

import type { FC } from 'react';

export const StatusTag: FC<StatusTagProps> = ({ status }) => {
  const statusData = useMemo(
    () => MIGRATION_STATUSES.find(({ id }) => id === status),
    [status]
  );

  return (
    <Tag
      icon={statusData?.icon || null}
      color={statusData?.color || TAG_STATUS_DEFAULT}
      data-testid="migration-status"
    >
      {statusData?.label || '-'}
    </Tag>
  );
};
